"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTextValueFormatter = void 0;
const defaultTextValueFormatter = (fileList) => {
    return fileList ? Array.from(fileList, (file) => file.name).join(', ') : '';
};
exports.defaultTextValueFormatter = defaultTextValueFormatter;
//# sourceMappingURL=defaultTextValueFormatter.js.map